import {ActionTree} from "vuex";
import {RootState} from "@service/store/types/RootState";
import {RoutingState} from "@service/store/types/RoutingState";
import {RoutingFrom} from "@service/types/RoutingFrom";

export const actions: ActionTree<RoutingState, RootState> = {
    addItem({commit}, item: RoutingFrom) {
        commit('add', item);
    },
    removeByRoute({commit, state}, routeName: string) {
        const index = state.froms.findIndex(item => item.routeName == routeName);
        if (index >= 0) {
            commit('remove', index);
        }
    }
}